module.exports = {"closeButtonText":"关闭","thumbNailAlt":"预览图片","next":"下一页","previous":"上一页","addNote":"添加笔记..."}


//////////////////
// WEBPACK FOOTER
// ./translations/zh-Hans.json
// module id = 39
// module chunks = 0